export const getIdWithPrefix = (id: string, prefix = 'ID'): string => {
  return `${prefix.toUpperCase()}-${id}`
}
